'use client';

import { MapPin } from 'lucide-react';
import Link from '@eliadmin/core/src/components/link';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { Breadcrumbs } from '@eliadmin/core/src/components/homepage/breadcrumbs';
import { ProductActions } from '@eliadmin/core/src/components/product/detail/product-actions';
import { ProductBottomInfo } from '@eliadmin/core/src/components/product/detail/product-bottom-info';
import { ProductDetailAvailability } from '@eliadmin/core/src/components/product/detail/product-detail-availability';
import { ProductDetailPrice } from '@eliadmin/core/src/components/product/detail/product-detail-price';
import { ProductHeader } from '@eliadmin/core/src/components/product/detail/product-header';
import { ProductImages } from '@eliadmin/core/src/components/product/detail/product-images';
import { ProductPaymentMethods } from '@eliadmin/core/src/components/product/detail/product-payment-methods';
import { ProductQuantity } from '@eliadmin/core/src/components/product/detail/product-quantity';
import { ProductVariants } from '@eliadmin/core/src/components/product/detail/variants/product-variants';
import { CarouselProvider } from '@eliadmin/core/src/components/ui/carousel-context';
import { Separator } from '@eliadmin/core/src/components/ui/separator';
import { useVariantsStore } from '@eliadmin/core/src/stores/variant-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export function ProductInfo() {
  const product = useVariantsStore(state => state.product);

  return (
    <section className={cn('custom-section', 'bg-[#FCFBFF] pb-10 pt-10 sm:pb-0 sm:pt-[50px]')}>
      <div
        className={cn(
          'custom-container',
          'flex flex-col items-start justify-start gap-6 sm:gap-8 md:flex-row md:justify-between',
        )}
      >
        <div className="w-full md:max-w-[588px]">
          <CarouselProvider>
            <ProductImages />
          </CarouselProvider>
        </div>
        <div className="flex w-full flex-col items-start justify-start gap-6 md:max-w-[564px]">
          <Breadcrumbs breadcrumb={product?.breadcrumb} product={product?.name} />
          <ProductHeader />
          <ProductVariants />
          <ProductDetailAvailability inDetail={true} />
          <ProductDetailPrice />
          <ProductQuantity />
          <Button asChild variant="outline" className="w-full whitespace-normal text-center">
            <Link href="/predajcovia" prefetch={false}>
              <MapPin className="h-5 w-5 shrink-0" aria-hidden="true" />
              <span>Nájsť najbližšieho predajcu</span>
            </Link>
          </Button>
          <ProductPaymentMethods />
          <Separator />
          <ProductActions />
          <Separator />
          <ProductBottomInfo />
        </div>
      </div>
    </section>
  );
}
